import { Card, Image, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useState, Fragment } from "react";
import likeclicked from "../../assets/images/job/likeclicked.svg";
import like from "../../assets/images/job/liked.svg";
import { BsEye } from "react-icons/bs";
import Tippy from "@tippyjs/react";
import "tippy.js/animations/scale.css";
import Url from "components/Url";
import { FaTools } from "react-icons/fa"; // Icon for skills

const JobListingListviewCard = ({ item, fav, setFav, Favorite, Apply, getTimePassed }) => {
  if (!item) {
    console.error("Job item is undefined");
    return null;
  }

  const url1 = Url();
  const s3 = url1["s3"];
  const url = url1["url"];
  const [s3url, setS3url] = useState(s3 + "imgupload/");

  return (
    <Card className="card-bordered mb-4 card-hover position-relative">
      {item?.activity_rank > 0 && (
        <Col xs={5} md={4} className="d-flex justify-content-end">
          <Fragment>
            <span className="position-absolute top-0 end-0 p-1" style={{ marginRight: "60px", color: "var(--geeks-primary)", marginTop: "15px" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-lightning-fill"
                viewBox="0 0 16 16"
              >
                <path d="M5.52.359A.5.5 0 0 1 6 0h4a.5.5 0 0 1 .474.658L8.694 6H12.5a.5.5 0 0 1 .395.807l-7 9a.5.5 0 0 1-.873-.454L6.823 9.5H3.5a.5.5 0 0 1-.48-.641l2.5-8.5z"></path>
              </svg>
              <span>Actively Hiring</span>
            </span>
          </Fragment>
        </Col>
      )}
      <Card.Body>
        <Row>
          <Col md={1} className="mb-3 mb-md-0">
            <Image
              src={item?.org_logo ? s3url + item.org_logo : "/path-to-default-logo.png"}
              alt="Company Logo"
              className="icon-shape border rounded-circle"
              style={{ height: "56px", width: "56px" }}
            />
          </Col>
          <Col md={11} className="mt-3 mt-md-0">
            <div className="d-flex justify-content-between mb-3">
              <div>
                <h3 className="mb-1 fs-4">
                  <Link to={`/internship-details/${item.id}`} className="text-inherit">
                    {item.internship_details}
                  </Link>
                </h3>
                <p className="mb-0">
                  <span className="text-muted">at {item?.org_name || "Unknown Company"}</span>
                </p>
              </div>
              <div>
                <img
                  src={fav?.has(item?.id) ? likeclicked : like}
                  alt="Favorite"
                  style={{ cursor: "pointer" }}
                  onClick={() => Favorite(item?.id)}
                />
              </div>
            </div>
            <Row className="text-muted mb-2">
              <Col xs={12} md={4} className="mb-2 mb-md-0">
                <i className="fe fe-briefcase me-1"></i>
                Duration: {item?.duration1}
                {item?.duration2 === "M" ? " Months" : " Weeks"}
              </Col>
              {/* Location Fix - Ensures it stays on one line */}
              <Col xs={12} md={4} className="mb-2 mb-md-0 d-flex align-items-center">
                <i className="fe fe-map-pin me-1"></i>
                <span className="text-truncate text-nowrap overflow-hidden" style={{ maxWidth: "100%" }}>
                  {item?.location || "Not specified"}
                </span>
              </Col>
              <Col xs={12} md={4}>
                <span className="text-muted">&#8377;</span>
                Stipend: {item?.compensation1 ? `${item.compensation1} per month` : "Not disclosed"}
              </Col>
            </Row>
            <Row className="text-muted mb-2">
              {/* Skills Fix - Ensures skills stay on one line */}
              <Col xs={12} md={4} className="mb-2 mb-md-0 d-flex align-items-center">
                <FaTools className="me-1" />
                <span className="text-truncate text-nowrap overflow-hidden" style={{ maxWidth: "100%" }}>
                  Skills: {item?.skill || "Not specified"}
                </span>
              </Col>
              <Col xs={12} md={4} className="mb-2 mb-md-0">
                {/* <i className="fe fe-clock me-1"></i> */}
                <i className="fe fe-calendar me-1"></i>
                Posted: {getTimePassed(item?.posting_date)}
              </Col>
              <Col xs={12} md={4}>
                <i className="fe fe-clock me-1"></i>
                Starts: Start Immediately
              </Col>
            </Row>
            {item.impressions > 0 && (
              <Fragment>
                <Row className="mt-1">
                  <Col xs={6} className="mt-2 d-flex justify-content-start">
                    <span style={{ color: "var(--geeks-primary)" }} className="ml-auto">
                      <BsEye size={13} />
                      <span className="small ms-1">{item.impressions} impressions</span>
                    </span>
                  </Col>
                </Row>
              </Fragment>
            )}
            <Row className="mt-1">
              <Col xs={12} className="mt-2 d-flex justify-content-end">
                <Link to={`/internship-details/${item.id}`} className="text-inherit me-1">
                  <button type="button" className="btn btn-sm btn-outline-warning" style={{ marginRight: "10px" }}>
                    More details
                  </button>
                </Link>
                <button type="button" className="btn btn-primary btn-sm" onClick={() => Apply(item.id)}>
                  Apply Now
                </button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default JobListingListviewCard;

